import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=ae31ead6&scoped=true"
import script from "./Thumb.vue?vue&type=script&lang=ts"
export * from "./Thumb.vue?vue&type=script&lang=ts"
import style0 from "./Thumb.vue?vue&type=style&index=0&id=ae31ead6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae31ead6",
  null
  
)

export default component.exports